import { Card, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ProductRow } from "./ProductRow";
import { TankMixRateSection } from "./TankMixRateSection";
import { useTranslation } from "react-i18next";
import { type ReactElement, useMemo } from "react";
import { formatTranslation } from "../../../../../../../shared/utils/translationUtils";
interface TreatmentCardProps {
  pIndex: number;
  item: any; // Replace 'any' with a specific type if available
  formData: any[]; // Replace 'any' with a specific type if available
  productOptions: any[]; // Replace 'any' with a specific type if available
  loading: boolean;
  isLoading: boolean;
  handleChangeFormData: (data: any, refresh?: boolean) => void;
  handleRemoveTreatment: (pIndex: number) => void;
  searchLoading: boolean;
  handleSearch: (value: string) => void;
}

export const TreatmentCard = ({
  pIndex,
  item,
  formData,
  productOptions,
  loading,
  isLoading,
  handleRemoveTreatment,
  handleChangeFormData,
  handleSearch,
  searchLoading,
}: TreatmentCardProps): ReactElement => {
  const { t } = useTranslation();

  function handleAddProduct(index: number): void {
    const updatedProducts = [...formData[index].products];
    updatedProducts.push({ values: "", label: "", rate: 0 });
    formData[index].products = updatedProducts;
    handleChangeFormData([...formData], true);
  }

  const options = useMemo(() => {
    const selectedValues = item.products
      .map((product: any) => product.value)
      .filter(Boolean);
    return productOptions.map((option) => ({
      ...option,
      disabled: selectedValues.includes(option.value),
    }));
  }, [item.products, productOptions]);

  return (
    <Card>
      <div className="input-container">
        <div className="product-config">
          <h3 className="treatment-title">
            {`${formatTranslation(
              t("createProtocol.products.biologicals.product.treatmentTitle")
            )} ${pIndex + 1}`}
          </h3>
          {formData.length > 1 && (
            <DeleteOutlined
              size={18}
              color="red"
              onClick={() => {
                handleRemoveTreatment(pIndex);
              }}
              style={{ color: "red", fontSize: "18px" }}
            />
          )}
        </div>
        <div>
          {item.products.map((product: any, index: number) => (
            <ProductRow
              key={index}
              handleSearch={handleSearch}
              index={index}
              product={product}
              productOptions={options}
              loading={loading}
              isLoading={isLoading}
              handleChangeFormData={handleChangeFormData}
              formData={formData}
              pIndex={pIndex}
              searchLoading={searchLoading}
              length={item.products.length}
            />
          ))}
          <div className="mt-3">
            <Button
              type="link"
              onClick={() => {
                handleAddProduct(pIndex);
              }}
              className="add-product-btn"
              disabled={loading || isLoading}
            >
              {formatTranslation(
                t("createProtocol.products.biologicals.product.addProduct")
              )}
            </Button>
          </div>
          <TankMixRateSection
            loading={loading}
            item={item.tank_mix_rate ?? {}}
            formData={formData}
            pIndex={pIndex}
            handleChangeFormData={handleChangeFormData}
          />
        </div>
      </div>
    </Card>
  );
};
